import React, { Component } from "reactn";
import { LinearProgress, Button, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { BeautifulDialog } from "./BaseDialog";

export default class ProgressDialog extends Component {
    state = {
        title: this.props.title,
        message: this.props.message,
        progress: 0,
    };

    setTitle = title => this.setState({ title });
    setMessage = message => this.setState({ message });
    setProgress = progress => this.setState({ progress });

    render = () => {
        const { title, progress, message } = this.state;

        let elemMessage = null;
        if (message) {
            elemMessage = <div>{message}</div>;
        }

        let elemProgress;
        if (progress) {
            elemProgress = <LinearProgress variant="determinate" value={progress} />;
        } else {
            elemProgress = <LinearProgress />;
        }

        let elemCancel = null;
        if (this.props.onCancel) {
            elemCancel = (
                <Button
                    onClick={this.props.onCancel}
                >Cancel</Button>
            );
        }

        return (
            <BeautifulDialog>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    {elemMessage}
                    {elemProgress}
                </DialogContent>
                <DialogActions>
                    {elemCancel}
                </DialogActions>
            </BeautifulDialog>
        );
    };
}
